import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback } from 'react';
import cx from 'classnames';
import withMemo from '../../../../decorators/withMemo';
import { renderComponent } from '../../../../helpers/FormHelpers';
var Field = withMemo()(function (props) {
  var _fieldConfig$props;
  var fieldConfig = props.fieldConfig,
    fieldsProps = props.fieldsProps,
    formikProps = props.formikProps,
    _props$renderer = props.renderer,
    renderer = _props$renderer === void 0 ? renderComponent : _props$renderer,
    className = props.className;
  var values = formikProps.values,
    errors = formikProps.errors,
    touched = formikProps.touched,
    handleBlur = formikProps.handleBlur,
    isSubmitting = formikProps.isSubmitting,
    submitCount = formikProps.submitCount,
    setFieldValue = formikProps.setFieldValue;
  var onChange = useCallback(function (_ref) {
    var name = _ref.name,
      value = _ref.value;
    if (!fieldsProps || !fieldConfig) {
      return;
    }
    if (fieldsProps && fieldsProps[fieldConfig.name] && fieldsProps[fieldConfig.name].onChange) {
      fieldsProps[fieldConfig.name].onChange({
        name: name,
        value: value
      });
    }
    if (fieldConfig && fieldConfig.onChange) {
      fieldConfig.onChange({
        name: name,
        value: value
      });
    }
    setFieldValue(name, fieldConfig.mask ? fieldConfig.mask(value) : value);
  }, [fieldsProps, fieldConfig, setFieldValue]);
  var onBlur = useCallback(function (_ref2) {
    var name = _ref2.name;
    return handleBlur(name);
  }, [handleBlur]);
  if (!fieldConfig) {
    return null;
  }
  return renderer(_objectSpread(_objectSpread(_objectSpread({}, fieldConfig.props), fieldsProps && fieldsProps[fieldConfig.name]), {}, {
    className: cx(fieldsProps.className, (_fieldConfig$props = fieldConfig.props) == null ? void 0 : _fieldConfig$props.className, className),
    name: fieldConfig.name,
    required: fieldConfig.validation && fieldConfig.validation.indexOf('required') !== -1,
    value: values[fieldConfig.name],
    onChange: onChange,
    onBlur: onBlur,
    error: (touched[fieldConfig.name] || isSubmitting || submitCount > 0) && errors[fieldConfig.name] ? errors[fieldConfig.name] : ''
  }), fieldConfig.component);
});
export default Field;